import Service from "./service.abstract";

export default class BookmarkService extends Service {
    constructor(url: string) {
        super();
        this.requestedWithHeaders = true;
        this.url = url;
        this.errorTopic = "service.error.bookmark";
    }
}